import { pilotAccess } from "@/lib/pilot-access";
import { Features, User } from "@/types";

/**
 * Is a capability part of the clinic's plan? (SCRUM-140)
 *
 * This is the plan question on its own. `hasAccess` answers a different one —
 * plan AND role — and returns false when no `canView` argument is passed,
 * because it ends in `canView.some(...)` over an empty list. Calling it with a
 * feature and nothing else, as the Google Agenda blocks did, is therefore
 * always false and hides the block from everyone.
 *
 * The rule mirrors `App\Models\Tenant::hasFeature` on the API: the active
 * subscription plan decides, and a clinic still in trial with no plan keeps
 * access. A user that has not loaded yet has no plan payload, so the caller
 * gets false and shows the locked state rather than flashing the feature.
 */
export function hasFeature(
  user: User | null | undefined,
  feature: keyof Features
): boolean {
  if (!user?.subscription?.is_active && (pilotAccess(user).hasPilot || user?.pilot_read_only)) return true;
  const features = user?.subscription?.features;

  if (features) {
    return features[feature] === true;
  }

  return user?.is_trial === true;
}
